export enum ECountryCode {
  AZ = 'AZ',
}

export enum ETrendName {
  DOWN = 'down',
  UP = 'up',
  NEUTRAL = 'neutral',
}

export enum ERefetchType {
  ALWAYS = 'always',
  ALL = 'all',
}

export enum ELanguageCode {
  AZ = 'az',
  EN = 'en',
  RU = 'ru',
}

export enum EPackageType {
  FREE = 'free',
}
